import { googleLogout } from '@react-oauth/google';
import { useAuth } from '@workos-inc/authkit-react';
import { useLogger } from '@cotera/client/v0/actions/framework/logger';
import { clearBearerTokenCache } from './bearer-token-cache';

/**
 * Hook that provides a logout function.
 *
 * Handles Google auth cleanup, Sentry context clearing, server session
 * revocation, and WorkOS signOut.
 */
export const useLogout = () => {
  const logger = useLogger();
  const { signOut } = useAuth();

  const logout = async () => {
    clearBearerTokenCache();
    googleLogout();
    logger.clearUser();

    try {
      // Use navigate: false so signOut clears the session data and
      // invalidates the WorkOS session without calling window.location.assign,
      // which would race with our own redirect below.
      await signOut({ navigate: false });
    } catch {
      // signOut may fail if there's no active session
    }

    window.location.assign('/login');
  };

  return { logout };
};
